import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { Trans_mex } from '../../consts/translate_mex';

@Pipe({
    name: 'mexTranslate',
    standalone: false
})
export class MexTranslatePipe implements PipeTransform {

  constructor(public _gS: GlobalService) {
  }

  transform(value: any, project?: any): any {
    if (project) {
      if (project.production_center_id == 2) {
        if (this._gS.getLenguage() === 'esp') {
      		var e: any;
          e = Trans_mex[value.toString().toLowerCase()];
          if (e) return e;
          else return value;
        } 
        else return value;
      }
      else return value;
    }
    else return value;
  }
}
